import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  -webkit-font-smoothing: antialiased;
`;
export const ContainerImage = styled.div`
  display: flex;
  height: 100%;
  width: 70%;

  @media only screen and (max-width: 940px) {
    width: 100%;
  }
`;
export const Img = styled.img`
  display: flex;
  width: 100%;
  height: 100vh;
`;
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;

  @media only screen and (max-width: 940px) {
    display: flex;
    position: absolute;
    background-color: white;
    width: 400px;
    height: 600px;
    border-radius: 0.5rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
export const Text = styled.div`
  font-family: Inter;
  color: ${color.grey1};
  font-size: 24px;

  @media only screen and (max-width: 1100px) {
    font-size: 20px;
  }
`;
export const BaseButtom = styled.button`
  display: flex;
  justify-content: center;
  height: 54px;
  width: 70%;
  background: linear-gradient(268.28deg, #06d986 0%, rgba(6, 217, 134, 0) 100%),
    #4a76fb;
  border-radius: 0.5rem;
  color: white;
  font-family: Inter;
  align-items: center;
  font-size: 1rem;
  cursor: pointer;

  :hover {
    background: linear-gradient(
        268.28deg,
        #04c67a 0%,
        rgba(6, 217, 134, 0) 100%
      ),
      #4068e0;
  }
`;
export const SizedBox = styled.div``;
export const LogoSellit = styled.img`
  @media only screen and (max-width: 1100px) {
    width: 200px;
  }
`;
export const Loading = styled(materialUI.CircularProgress)``;

export const TermosLink = styled.span`
  display: flex;
  align-items: center;
  font-family: Inter;
  color: ${color.primary};
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
